import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { selectUser } from 'entities/user/selectors';

const WIDGET_URL = 'https://static.zdassets.com/ekr/snippet.js';
const WIDGET_ID = 'ze-snippet';
const WIDGET_SNIPPET_KEY = '5a807d18-5f72-4386-b5c6-447ceb4bf79b';

declare const zE: (prompt1: string, prompt2: string, value?: unknown) => void;

declare const window: Window & { zE: typeof zE };

const loadScript = async (): Promise<void> =>
  new Promise((resolve) => {
    const script = document.createElement('script');
    script.id = WIDGET_ID;
    script.src = `${WIDGET_URL}?key=${WIDGET_SNIPPET_KEY}`;
    script.addEventListener('load', resolve);
    document.body.appendChild(script);
  });


const ZendeskWidget = () => {
  // Note a z-index is applied to the widget in organizer/app/global-styles.jsx on #launcher
  const [isLoaded, setIsLoaded] = useState(!!window.zE);

  useEffect(() => {
    let mounted = true;

    if (!isLoaded) {
      loadScript().then(
        () => {
          if (!mounted) {
            return;
          }
          setIsLoaded(true);
        },
        (e) => {
          // eslint-disable-next-line no-console
          console.error(`Failed to load zendesk: ${e}`);
        }
      );
    }

    return () => {
      mounted = false;
      if (typeof window.zE !== 'undefined') {
        // If PS team switches from webWidget to messenger, the hide function would throw.
        try {
          zE('webWidget', 'hide');
        } catch (e) {
          zE('messenger', 'hide');
        }
      }
    };
    // We'll disable the linter rule as we only want this to run at first run
  }, []);

  return null;
};

const SupportChatWidget = () => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up('md'));
  const user = useSelector(selectUser);

  if (user && isLarge) {
    return <ZendeskWidget />;
  }
  return null;
};

export default SupportChatWidget;
